import { put, takeLatest } from "redux-saga/effects";
import {
  requestSmartSuiteAgreement,
  requestUpdateSmartSuiteAgreement,
  requestCreateSmartSuiteAgreement,
  requestUpdateAgreementSignedDocument,
  requestUpdateAgreementKycDocuments,
  requestDeleteSmartSuiteAgreement,
  requestExpansionSmartSuiteAgreement,
  requestAgrExpansionDetails,
  requestAgreementById,
  requestRenewalCreateSmartSuiteAgreement,
  requestUpdateAgreementDocuments,
  requestSmartSuiteAgreementDocument,
  requestLinkAgreementAccount,
  requestVerifySmartSuiteAgreement,
  requestSmartSuiteAgreementLog,
  requestClientTicketsData,
  requestSendMoveInEmail,
  requestLienList,
  fetchEntityNames,
  fetchAgreementsByEntity,
  fetchClientAgreementList
} from "services/smartSuiteAgreement";
import {
  fetchSmartSuiteAgreementListRequest,
  fetchSmartSuiteAgreementListSuccess,
  fetchSmartSuiteAgreementListFaliure,
  fetchAllSmartSuiteAgreementListRequest,
  fetchAllSmartSuiteAgreementListSuccess,
  fetchAllSmartSuiteAgreementListFaliure,
  createSmartSuiteAgreementRequest,
  createSmartSuiteAgreementSuccess,
  createSmartSuiteAgreementFailure,
  updateSmartSuiteAgreementRequest,
  updateSmartSuiteAgreementSuccess,
  updateSmartSuiteAgreementFailure,
  verifySmartSuiteAgreementFailure,
  verifySmartSuiteAgreementSuccess,
  verifySmartSuiteAgreementRequest,
  updateAgreementKycDocumentsRequest,
  updateAgreementKycDocumentsFailure,
  updateAgreementKycDocumentsSuccess,
  updateAgreementSignedDocumentRequest,
  updateAgreementSignedDocumentFailure,
  updateAgreementSignedDocumentSuccess,
  deleteSmartSuiteAgreementRequest,
  deleteSmartSuiteAgreementSuccess,
  deleteSmartSuiteAgreementFailure,
  expansionSmartSuiteAgreementRequest,
  expansionSmartSuiteAgreementSuccess,
  expansionSmartSuiteAgreementFailure,
  fetchAgrExpansionDetailsRequest,
  fetchAgrExpansionDetailsSuccess,
  fetchAgrExpansionDetailsFailure,
  fetchAgreementByIdRequest,
  fetchAgreementByIdSuccess,
  fetchAgreementByIdFailure,
  createRenewalSmartSuiteAgreementRequest,
  createRenewalSmartSuiteAgreementSuccess,
  createRenewalSmartSuiteAgreementFailure,
  updateAgreementDocumentsRequest,
  updateAgreementDocumentsSuccess,
  updateAgreementDocumentsFailure,
  fetchSmartSuiteAgreementDocumentListRequest,
  fetchSmartSuiteAgreementDocumentListSuccess,
  fetchSmartSuiteAgreementDocumentListFailure,
  linkAgreementAccountRequest,
  linkAgreementAccountSuccess,
  linkAgreementAccountFailure,
  fetchSmartSuiteAgreementListRequestLog,
  fetchSmartSuiteAgreementListLogSuccess,
  fetchSmartSuiteAgreementListLogFaliure,
  clientTicketsListRequest,
  clientTicketsListSuccess,
  clientTicketsListFailure,
  IsNoticeEmailSendFailure,
  IsNoticeEmailSendSuccess,
  requestIsNoticeEmailSend,
  moveInEmailSendFailure,
  moveInEmailSendSuccess,
  requestMoveInEmailSend,
  fetchLienListSuccess,
  fetchLienListError,
  fetchLienListRequest,
  fetchEntityNamesRequest,
  fetchEntityNamesSuccess,
  fetchEntityNamesFailure,
  fetchAgreementsByEntityRequest,
  fetchAgreementsByEntitySuccess,
  fetchAgreementsByEntityFailure,
  fetchClientAgreementListRequest,
  fetchClientAgreementListSuccess,
  fetchClientAgreementListFailure
} from "redux/reducers/smartSuiteAgreement";

export function* watchAgreementSaga() {
  yield takeLatest(fetchSmartSuiteAgreementListRequest, fetchsmartsuitelist);
  yield takeLatest (fetchLienListRequest,fetchLienLists)
  yield takeLatest(fetchAllSmartSuiteAgreementListRequest, fetchAllsmartsuitelist);
  yield takeLatest(fetchSmartSuiteAgreementListRequestLog, fetchsmartsuitelistLog);
  yield takeLatest(updateSmartSuiteAgreementRequest, updateSmartSuiteAgreement);
  yield takeLatest(verifySmartSuiteAgreementRequest,verifySmartSuiteAgreement);
  yield takeLatest(fetchEntityNamesRequest, fetchEntityNamesSaga);
  yield takeLatest(fetchAgreementsByEntityRequest, fetchAgreementsByEntitySaga);
  yield takeLatest(fetchClientAgreementListRequest, fetchClientAgreementListSaga);
  yield takeLatest(createSmartSuiteAgreementRequest, createSmartSuiteAgreement);
  yield takeLatest(
    updateAgreementKycDocumentsRequest,
    updateAgreementKycDocuments
  );
  yield takeLatest(
    updateAgreementSignedDocumentRequest,
    updateAgreementSignedDocument
  );
  yield takeLatest(deleteSmartSuiteAgreementRequest, deleteSmartSuiteAgreement);
  yield takeLatest(
    expansionSmartSuiteAgreementRequest,
    expansionSmartSuiteAgreement
  );
  yield takeLatest(fetchAgrExpansionDetailsRequest, fetchAgrExpansionDetails);
  yield takeLatest(fetchAgreementByIdRequest, fetchAgreementById);
  yield takeLatest(clientTicketsListRequest,fetchClientTickets)
  yield takeLatest(requestMoveInEmailSend,fetchSendEmailInAgreement)
  yield takeLatest(
    createRenewalSmartSuiteAgreementRequest,
    createRenewalSmartSuiteAgreement
  );
  yield takeLatest(updateAgreementDocumentsRequest, updateAgreementDocuments);
  yield takeLatest(
    fetchSmartSuiteAgreementDocumentListRequest,
    fetchSmartSuiteAgreementDocument
  );
  yield takeLatest(linkAgreementAccountRequest, linkAgreementAccount);
}
function* fetchsmartsuitelist({ payload }) {
  try {
    const response = yield requestSmartSuiteAgreement(payload);
    yield put(fetchSmartSuiteAgreementListSuccess(response));
  } catch (error) {
    yield put(
      fetchSmartSuiteAgreementListFaliure("Failed to get list of Agreements")
    );
  }
}
function* fetchLienLists({payload}){
  try{
    const response = yield requestLienList(payload)
    yield put(fetchLienListSuccess(response));
  }catch(error){
    yield put(
      fetchLienListError("Failed to get list of Lien Lists")
    )
  }
}
function* fetchAllsmartsuitelist({ payload }) {
  try {
    const response = yield requestSmartSuiteAgreement(payload);
    if(!payload.cancelRequest){
      yield put(fetchAllSmartSuiteAgreementListSuccess(response));
    }
  } catch (error) {
    yield put(
      fetchAllSmartSuiteAgreementListFaliure("Failed to get list of Agreements")
    );
  }
}

function* fetchsmartsuitelistLog({payload}){
   try{
    const response = yield requestSmartSuiteAgreementLog(payload);
     yield put(fetchSmartSuiteAgreementListLogSuccess(response))
   }catch(error){
    yield put(fetchSmartSuiteAgreementListLogFaliure(error))
   }
}
/**
 *
 * @param {SmartProposalState} param0
 */
function* createSmartSuiteAgreement({ payload }) {
  console.log('inn createSmartSuiteAgreement with payload', payload)
  try {
    const response = yield requestCreateSmartSuiteAgreement(payload);
    if (!response) {
      yield put(
        createSmartSuiteAgreementFailure("Failed to create smart suite agreement")
      );
      // throw new Error('Empty response received');
    } else {
      yield put(createSmartSuiteAgreementSuccess(response.data));
    }

  } catch (error) {
    console.log('in error createSmartSuiteAgreement')
    yield put(
      createSmartSuiteAgreementFailure("Failed to create smart suite agreement")
    );
  }
}

/**
 *
 * @param {SmartSuiteAgreement} param0
 */
function* updateSmartSuiteAgreement({ payload }) {
  try {
    const response = yield requestUpdateSmartSuiteAgreement(payload);
    yield put(updateSmartSuiteAgreementSuccess(response.data));
  } catch (error) {
    yield put(
      updateSmartSuiteAgreementFailure("Failed to update smart suite agreement")
    );
  }
}
function* verifySmartSuiteAgreement({payload}){
  try{
    const response = yield requestVerifySmartSuiteAgreement(payload);
    yield put(verifySmartSuiteAgreementSuccess(response.data))
  }catch(error){
    yield put(
      verifySmartSuiteAgreementFailure("Failed to update smart suite agreement")
    )
  }
}

function* fetchEntityNamesSaga(){
  try{
    const response = yield fetchEntityNames();
    yield put(fetchEntityNamesSuccess(response))
  }catch(error){
    yield put(fetchEntityNamesFailure("Failed to fetch entity names"))
  }
}

function* fetchAgreementsByEntitySaga({payload}){
  try{
    const response = yield fetchAgreementsByEntity(payload);
    yield put(fetchAgreementsByEntitySuccess(response))
  }catch(error){
    yield put(fetchAgreementsByEntityFailure("Failed to fetch agreements by entity"))
  }
}

function* fetchClientAgreementListSaga({payload}){
  try{
    const response = yield fetchClientAgreementList(payload);
    yield put(fetchClientAgreementListSuccess(response))
  }catch(error){
    yield put(fetchClientAgreementListFailure("Failed to fetch client agreements"))
  }
}

/**
 *
 * @param { AgreementKycDocument } param0
 */
function* updateAgreementKycDocuments({ payload }) {
  try {
    const response = yield requestUpdateAgreementKycDocuments(payload);
    yield put(updateAgreementKycDocumentsSuccess(response.data));
  } catch (error) {
    yield put(updateAgreementKycDocumentsFailure("Failed to update data"));
  }
}

/**
 *
 * @param { AgreementSignedDocument } param0
 */
function* updateAgreementSignedDocument({ payload }) {
  try {
    const response = yield requestUpdateAgreementSignedDocument(payload);
    yield put(updateAgreementSignedDocumentSuccess(response.data));
  } catch (error) {
    yield put(
      updateAgreementSignedDocumentFailure("Failed to get list of Leads")
    );
  }
}

function* deleteSmartSuiteAgreement({ payload }) {
  try {
    const response = yield requestDeleteSmartSuiteAgreement(payload);
    yield put(deleteSmartSuiteAgreementSuccess(response));
  } catch (error) {
    yield put(
      deleteSmartSuiteAgreementFailure(
        "Failed to delete of Smart Suite Agreement"
      )
    );
  }
}

/**
 *
 * @param {SmartSuiteAgreement} param0
 */
function* expansionSmartSuiteAgreement({ payload }) {
  try {
    const response = yield requestExpansionSmartSuiteAgreement(payload);
    yield put(expansionSmartSuiteAgreementSuccess(response.data));
  } catch (error) {
    yield put(
      expansionSmartSuiteAgreementFailure(
        "Failed To Update Agreement"
      )
    );
  }
}

function* fetchAgrExpansionDetails({ payload }) {
  try {
    const response = yield requestAgrExpansionDetails(payload);
    yield put(fetchAgrExpansionDetailsSuccess(response));
  } catch (error) {
    yield put(
      fetchAgrExpansionDetailsFailure("Failed to get list of Agreements")
    );
  }
}

function* fetchAgreementById({ payload }) {
  try {
    const response = yield requestAgreementById(payload);
    yield put(fetchAgreementByIdSuccess(response));
  } catch (error) {
    yield put(fetchAgreementByIdFailure("Failed to get Agreement"));
  }
}

function* fetchClientTickets({ payload }) {
  try {
    const response = yield requestClientTicketsData(payload);
    yield put(clientTicketsListSuccess(response));
  } catch (error) {
    yield put(clientTicketsListFailure("Failed to get Client ticket Data"));
  }
}
function* fetchSendEmailInAgreement({ payload }) {
  try {
    const response = yield requestSendMoveInEmail(payload);
    yield put(moveInEmailSendSuccess(response));
  } catch (error) {
    yield put(moveInEmailSendFailure("Failed to get Client ticket Data"));
  }
}

/**
 *
 * @param {SmartProposalState} param0
 */
function* createRenewalSmartSuiteAgreement({ payload }) {
  try {
    const response = yield requestRenewalCreateSmartSuiteAgreement(payload);
    yield put(createRenewalSmartSuiteAgreementSuccess(response.data));
  } catch (error) {
    yield put(
      createRenewalSmartSuiteAgreementFailure(
        "Failed to create Renewal smart suite agreement"
      )
    );
  }
}

function* updateAgreementDocuments({ payload }) {
  try {
    const response = yield requestUpdateAgreementDocuments(payload);
    yield put(updateAgreementDocumentsSuccess(response.data));
  } catch (error) {
    yield put(updateAgreementDocumentsFailure("Failed to update data"));
  }
}

function* fetchSmartSuiteAgreementDocument({ payload }) {
  try {
    const response = yield requestSmartSuiteAgreementDocument(payload);
    yield put(fetchSmartSuiteAgreementDocumentListSuccess(response));
  } catch (error) {
    yield put(
      fetchSmartSuiteAgreementDocumentListFailure(
        "Failed to get list of Agreements Documents"
      )
    );
  }
}

function* linkAgreementAccount({ payload }) {
  try {
    const response = yield requestLinkAgreementAccount(payload);
    yield put(linkAgreementAccountSuccess(response.data));
  } catch (error) {
    yield put(
      linkAgreementAccountFailure("Failed to update smart suite agreement")
    );
  }
}
